import { withTranslation } from 'react-i18next';
import { Header, Footer, config } from '@cmsgov/ds-healthcare-gov';
import IncomeCalculator from './IncomeCalculator';

config({
  errorPlacementDefault: 'bottom',
});

function App() {
  return (
    <>
      <Header subpath="income-calculator/" skipNavHref="#main-body-content" />
      <IncomeCalculator />
      <Footer />
    </>
  );
}

export default withTranslation()(App);
